import {
  IconX,
  IconUser,
  IconBrandWhatsapp,
  IconArrowRight,
  IconMenu3,
  IconBrandLinkedin,
  IconBrandInstagram,
  IconPlus,
  IconMinus,
  IconBrandYoutube,
  IconBrandFacebook,
  IconArrowLeft,
  IconCurrencyDollar,
  IconChartLine,
  IconUsers,
  IconCalendarMonth,
  IconMapPin,
} from '@tabler/icons-react'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'

const ICON = {
  IconMapPin,
  IconBrandFacebook,
  IconUser,
  IoIosArrowDown,
  IoIosArrowUp,
  IconPlus,
  IconMinus,
  IconCurrencyDollar,
  IconChartLine,
  IconUsers,
  IconCalendarMonth,
  IconX,
  IconMenu3,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandWhatsapp,
  IconArrowLeft,
  IconArrowRight,
  IconBrandYoutube,
}

export default ICON
